export default __webpack_public_path__ + "static/media/Support.f91e8848.png";